(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wfl-sample-ai-project-delivery"]) return;
  try {
    
document.querySelectorAll("[data-wfl-reader-select]").forEach(select => select.addEventListener("change", () => { window.location.href = select.value; }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfl-sample-ai-workflow-automation"]) return;
  try {
    
document.querySelectorAll("[data-wfl-reader-select]").forEach(select => select.addEventListener("change", () => { window.location.href = select.value; }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfl-sample-client-closeout"]) return;
  try {
    
document.querySelectorAll("[data-wfl-reader-select]").forEach(select => select.addEventListener("change", () => { window.location.href = select.value; }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfl-sample-client-delivery"]) return;
  try {
    
document.querySelectorAll("[data-wfl-reader-select]").forEach(select => select.addEventListener("change", () => { window.location.href = select.value; }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfl-sample-client-start"]) return;
  try {
    
document.querySelectorAll("[data-wfl-reader-select]").forEach(select => select.addEventListener("change", () => { window.location.href = select.value; }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfl-sample-foundation"]) return;
  try {
    
document.querySelectorAll("[data-wfl-reader-select]").forEach(select => select.addEventListener("change", () => { window.location.href = select.value; }));

  } catch(e) { console.error(e); }
})();
})();
